<template>
  <transition name="fade-slide">
    <div v-show="showBackToTop" class="back-to-top" @click="scrollToTop">
      <el-icon><ArrowUp /></el-icon>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';
import { ArrowUp } from '@element-plus/icons-vue';

const showBackToTop = ref(false);
let scrollTimer: ReturnType<typeof setTimeout> | null = null;

// 回到顶部功能
const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

// 滚动事件处理函数 - 专注于控制回到顶部按钮的显示
const handleScroll = () => {
  // 使用防抖处理，避免频繁触发
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
  
  scrollTimer = setTimeout(() => {
    const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
    
    // 控制回到顶部按钮的显示与隐藏（当滚动超过300px时显示）
    showBackToTop.value = currentScrollTop > 300;
  }, 10);
};

// 组件挂载时添加滚动监听
onMounted(() => {
  window.addEventListener('scroll', handleScroll, { passive: true });
});

// 组件卸载时移除滚动监听
onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll);
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
});
</script>

<style scoped>
.back-to-top {
  position: fixed;
  right: 40px;
  bottom: 40px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #3674b1;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  z-index: 1002;
  transition: background-color 0.3s;
}

.back-to-top:hover {
  background-color: #3674b1;
}

/* 渐变动画 */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.fade-slide-enter-from,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* 响应式样式 */
@media (max-width: 768px) {
  .back-to-top {
    right: 25px;
    bottom: 25px;
    width: 45px;
    height: 45px;
  }
}

@media (max-width: 576px) {
  .back-to-top {
    right: 20px;
    bottom: 20px;
    width: 40px;
    height: 40px;
  }
}

@media (max-width: 480px) {
  .back-to-top {
    right: 15px;
    bottom: 15px;
    width: 35px;
    height: 35px;
  }
}
</style> 